import React from 'react';
import {
  Container, Col, Row,
} from '../../components/grid';
import {
  Heading1,
  Paragraph,
  Heading2,
  LinkStyled,
} from '../../components/typography';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import TheVideoPlayer from '../../components/TheVideoPlayer';

export default () => (
  <SidemenuLayout menuPicker="Anlaeg" activeSidemenu="VandkoeletFadoelsanlaeg">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>Vandkølet fadølsanlæg</Heading1>
          <Paragraph>
            Hos Skafte kan du leje et vandkølet fadølsanlæg. Det er en type anlæg, der er let at bruge og køler meget effektivt. Her på siden kan du læse mere om hvordan et vandkølet fadølsanlæg fungerer.
            Lej et <LinkStyled to="/fadoelsanlaeg">fadølsanlæg</LinkStyled> til din næste fest, arrangement eller event og server iskolde, læskende øl.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading2>Sådan virker et vandkølet fadølsanlæg</Heading2>
        </Col>
        <Col xs={12} doubleColumn paddingTop="0px">
          <Paragraph>
            Alle de anlæg vi lejer ud, er vandkølede. Der er hovedsageligt to forskellige modeller, når der er tale om et vandkølet fadølsanlæg. Anlægget har en vandkøler, hvor man kan hælde vand på. Vandet skal fyldes på op til kanten af røret.
            Ved levering og leje af vandkølet fadølsanlæg sørger vi selvfølgelig for, at der er vand nok på anlægget. Anlægget bruger ikke vand under festen.
          </Paragraph>
          <Paragraph>
            Der findes også en anden type vandkølet fadølsanlæg. Her er vandet lukket inde og man kan derfor ikke se ned i vandtanken. Der vil være nok vand påfyldt ved leveringen. Medmindre der løber vand ud, skal man slet ikke tænke på at fylde vand på anlægget under festen.
          </Paragraph>
          <Paragraph>
            Med begge vandkølede fadølsanlæg er det vigtigt, at de står vandret. Selvom vandtanken er nogenlunde lukket, så vil vandet løbe ud, hvis anlægget stilles på højkant eller bliver vippet eller tippet. Hvis der ikke er vand nok på anlægget, holder det op med at køle, og så skummer øllet hele tiden. Sørg derfor for at holde anlægget vandret hele tiden.
            Når anlægget er fyldt med vand, vejer det ca. 43 kg.
          </Paragraph>
          <Paragraph>
            Princippet i et vandkølet fadølsanlæg er sådan, at kompressoren fylder den ene halvdel af anlægget. I den anden halvdel er der en tank med ca. 12 liter vand. Vandkølede fadølsanlæg fungerer sådan, at ca. 2/3 af vandet i tanken skal fryses til is. Det er derfor, at anlægget skal være tændt nogle timer før man skal bruge det.
            Nede i de 12 liter vand er der et 14 meter langt rør. Øllet løber igennem det lange rør, som er dyppet ned i blandingen af is og vand og bliver derved afkølet.
          </Paragraph>
          <Paragraph>
            Øllet bliver altså først kølet på vejen op til hanen, lige før man tapper det, og ikke i selve fustagen. Under låget sidder en motor og drejer. Stiller man noget på låget, risikerer man, at motoren stopper og så begynder fadøllet at skumme.
          </Paragraph>
          <Paragraph>
            Har man flere vandkølede fadølsanlæg, er det vigtigt, at man placerer dem rigtigt i forhold til hinanden. Køleluften trækkes ind i den side hvor man kan se ribberne. Den varme luft blæses ud i den side, hvor man kan se kompressoren. Er man i tvivl, kan man evt. prøve med et stykke papir eller en serviet og se hvor indsugningen er.
          </Paragraph>
          <Paragraph>
            Det er vigtigt, at anlæggene ikke placeres således, at varm udblæsningsluft fra et anlæg trækkes ind som køleluft i et andet anlæg. Stil derfor anlæggene, så de blæser varm luft ud mod hinanden.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <Row>
        <Col xs={12} padding="0">
          <TheVideoPlayer
            url="fbAsc4Z5AfI?t=194"
            thumbnail="vandkoelede-anlaeg"
            chapters={[
            {
              time: '00:00',
              description: '00:00 - Opstilling af udstyr og tilslutning af strøm',
            },
            {
              time: '01:19',
              description: '01:19 - Tilslutning af fadøl og kulsyre til fadølsanlæg',
            },
            {
              time: '03:11',
              description: '03:11 - Sådan virker vandkølede fadølsanlæg',
            },
            {
              time: '06:06',
              description: '06:06 - Opsætning af fadølsbar og tappetårn',
            },
            {
              time: '07:13',
              description: '07:13 - Forberedelse før tapning af fadøl',
            },
            {
              time: '08:36',
              description: '08:36 - Sådan tapper du en perfekt fadøl',
            },
          ]}
          />
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
